import Vue from 'vue'

import './index.scss'
import './variables.scss'

import {

    Alert, Autocomplete, Button,
    ButtonGroup, Card, Cascader, Checkbox,
    CheckboxGroup, Col, DatePicker,
    // Others
    Dialog, Drawer, Dropdown, DropdownItem, DropdownMenu, Form,
    FormItem, Icon, InfiniteScroll, Input,
    InputNumber, Link, Loading,
    // Navigation
    Menu, MenuItem,
    MenuItemGroup, Message,
    MessageBox, Option,
    OptionGroup, Pagination, Popover, Progress,
    // Form
    Radio,
    RadioButton,
    RadioGroup, Row, Scrollbar, Select, Step, Steps, Submenu, Switch,
    // Data
    Table,
    TableColumn, TabPane, Tabs, Tag, TimePicker, TimeSelect, Tooltip, Transfer, Tree, Upload
} from 'element-ui'

import locale from 'element-ui/lib/locale'
import langEn from 'element-ui/lib/locale/lang/en'
import lang from 'element-ui/lib/locale/lang/zh-CN'
import cookie from 'js-cookie'
Vue.prototype.cookie = cookie;
const components = [
    // Base
    Row,
    Col,
    Button,
    ButtonGroup,
    Icon,
    Link,

    // Form
    Radio,
    RadioButton,
    RadioGroup,
    Checkbox,
    CheckboxGroup,
    Input,
    InputNumber,
    Autocomplete,
    Select,
    Switch,
    Option,
    OptionGroup,
    DatePicker,
    TimeSelect,
    TimePicker,
    Upload,
    Form,
    FormItem,
    Cascader,
    Transfer,

    // Data
    Table,
    TableColumn,
    Progress,
    Tree,
    Pagination,
    Tag,

    // Notice
    Alert,

    // Navigation
    Menu,
    Submenu,
    MenuItem,
    MenuItemGroup,
    Tabs,
    TabPane,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Steps,
    Step,

    // Others
    Dialog,
    Tooltip,
    Popover,
    Card,
    InfiniteScroll,
    Scrollbar,
    Drawer
]

// 循环注册全局组件
components.forEach(item => {
    Vue.use(item)
})
Vue.use(Loading.directive)


// Vue.use(Pagination, {
//     locale: {
//         ...langEn,
//         ...lang
//     }
// })
if((cookie.get('mfs_lang') == 'en-us' || cookie.get('mfs_lang') == 'en-US')) {
    locale.use({
        el: {
            ...langEn.el,
            pagination: {
                goto: '',
                pagesize: '',
                total: 'Total {total} piece',
                pageClassifier: ''
            },
        }
    })
} else {
    locale.use({
        el: {
            ...lang.el,
            pagination: {
                goto: '',
                pagesize: '',
                total: '共 {total} 条',
                pageClassifier: ''
            }
        }
    })
}


Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$message = Message
